import * as yup from 'yup'

const schema = yup.object().shape({
  data: yup.string().required('Campo obrigatório.'),
  status: yup.string().required('Campo obrigatório.'),
  tempoGestacao: yup
    .number()
    .required('Campo obrigatório.')
    .integer('número de dias inválido.')
    .typeError('Campo obrigatório.'),
  peso: yup.string().required('Campo obrigatório.').typeError('Campo obrigatório.')
})

export default schema
